var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{staticStyle:{"background":"white"}},[_c('v-col',{staticClass:"mb-10",attrs:{"md":"8","offset-md":"2"}},[_c('credit-card-form')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }